// extracted by mini-css-extract-plugin
export default {"map":"styles_map_map__tqYyQ"};